package app.spliddy.web.strings

import kotlin.String

internal object StringsDe : Strings {
  override val app_catch_phrase: String = "Mühelos Ausgaben aufteilen"

  override val app_is_under_construction: String = "🚧Diese Seite wird noch gebaut! 🚧"

  override val app_imprint: String = "Impressum"

  override val app_privacy_policy: String = "Datenschutzerklärung"

  override val app_download_app: String = "App Herunterladen"

  override val app_name: String? = null

  override val footer_built_with_love: String? = null
}
